import React from "react"

export default React.createClass({
  componentDidMount() {
    if (window.$ && $.tooltip) {
      let container = ReactDOM.findDOMNode(this)
      return $(container).tooltip({
        container: 'body',
        html: true
      })
    }
  },

  render() {
    return (
      <span data-toggle="tooltip" title={this.props.tooltip}>
        {this.props.children}
      </span>
    )
  }
})



// WEBPACK FOOTER //
// ./app/webpack/frontend/components/ReactTooltipTrigger.jsx